// extracted by mini-css-extract-plugin
export var container = "NcpscmgB";
export var hidden = "fLgIoDv0";
export var visible = "mTo-+6UH";
export var slideIn = "Dc3W+vsd";
export var textContainer = "_6-V+VIHM";
export var subtitle = "irHgxfk2";
export var icon = "juMI4psp";